const USER = 'integration_user';
const MANAGER = 'integration_manager';

export { USER, MANAGER };
